import authCopy from './authCopy';
import { isValidEmail, isValidPassword, isNonEmpty } from '../helpers/validators';

import { validateEmail } from './validations/validateEmail';
import { validateLogin } from './validations/validateLogin';
import { validatePassword } from './validations/validatePassword';

const { errors } = authCopy;

export { validateEmail, validatePassword, validateLogin };

export function validateEmailString(email) {
    if (!isNonEmpty(email)) {
        return 'Email address is required';
    } else if (!isValidEmail(email)) {
        return 'Please enter a valid email address.';
    }
    return null;
}

export function validatePasswordString(password) {
    if (!isNonEmpty(password)) {
        return 'Password is required.';
    } else if (!isValidPassword(password)) {
        return 'Please enter a minimum of 5 characters.';
    }
    return null;
}

export function validatePasswords(password, passwordConf) {
    let error;
    if (password !== passwordConf) {
        error = errors.passwordMatch;
    }
    return {
        password: validatePassword(password),
        passwordConf: validatePassword(passwordConf) || error,
    };
}
